export const ELECTRIC_SEAT_ADJUSTMENT = 17;
export const SPORTS_SEATS = 22;
export const HAS_LUMBAR_SUPPORT = 'hasLumbarSupport';
export const HAS_MASSAGE_SEATS = 'hasMassageSeats';
export const HAS_SEAT_VENTILATION = 'hasSeatVentilation';
